// Accueil authentifié — affiche le tableau de bord (KPIs + graphiques).
//
// Depuis Lot 3B, la page d'accueil n'est plus un sommaire de liens : c'est
// directement la vue portefeuille que David consulte le matin.

import { useTranslation } from "react-i18next";
import { AppShell } from "../components/AppShell";
import { DashboardHome } from "../components/DashboardHome";
import { useAuthStore } from "../stores/auth";

export function HomePage() {
  const { user, currentTenant, currentRole } = useAuthStore();
  const { t } = useTranslation();

  return (
    <AppShell>
      <div className="flex flex-col gap-1 mb-6">
        <h2 className="text-2xl font-semibold text-slate-900">
          {t("dashboard.hello")} {user?.full_name?.split(" ")[0] ?? ""}
        </h2>
        <p className="text-sm text-slate-500">
          {currentTenant
            ? `${t("dashboard.tenantActive")} : ${currentTenant.name} · ${t("dashboard.roleAdmin").replace("admin", currentRole ?? "member")}`
            : t("common.noData")}
        </p>
      </div>

      <DashboardHome />
    </AppShell>
  );
}
